export default __webpack_public_path__ + "static/media/ned.881cf43f.svg";